import { useMemo } from 'react';
import { mediaManagerPanelFileInfoCreateVideoClick } from '@wix/bi-logger-media-data/v2';
import { bi } from '../../../services/loggers/bi';
import { extractCommonBiFieldsFromItems } from '../../bi';
import { useFileType } from './useFileType';

export enum VideoCreationScript {
  CreateVideo = 'create_video',
  ReEdit = 're_edit',
}

export const useTrackCreateVideoToolClick = () => {
  const fileType = useFileType();

  return useMemo(
    () => ({
      trackCreateVideoToolClick: (actionName, items) =>
        bi.logger().report(
          mediaManagerPanelFileInfoCreateVideoClick({
            ...extractCommonBiFieldsFromItems(items, { fileType }),
            actionName,
          }),
        ),
    }),
    [fileType],
  );
};
